<template>
  <div>
    <div class="accessIndex__general_info">
      <div class="trainers__header--title">
        <div style="margin-bottom:30px" class="accessIndex__reload">
          <v-hover>
            <div  @click="getClients()" slot-scope="{ hover }" class="accessIndex__reload--container" :class="hover?'accessIndex__interaction--hover':''"  >
              <img src="../../../assets/img/reload_blue.svg">
            </div>
          </v-hover>
          <p  class="accessIndex__text--title" > {{segment.name.charAt(0).toUpperCase()+ segment.name.slice(1)}} {{segmentValue}}</p>
        </div>
        <v-breadcrumbs style="width: 100%">
          <v-icon slot="divider">chevron_right</v-icon>
          <v-breadcrumbs-item
            @click="$router.push({name: 'segments'})">
            Características de usuario
          </v-breadcrumbs-item>
          <v-breadcrumbs-item
            @click="$router.push({name: 'segments_value', params: {id: segment.id, name: segment.name.toLowerCase() }});">
            {{segment.name.charAt(0).toUpperCase()+ segment.name.slice(1)}}
          </v-breadcrumbs-item>
          <v-breadcrumbs-item
            disabled>
            {{segmentValue.charAt(0).toUpperCase()+ segmentValue.slice(1)}}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </div>
    </div>

    <v-data-table
      :headers="headers"
      :items="clientSegments"
      hide-actions
      class="elevation-1">
      <template v-if="clientSegments.length > 0" slot="items" slot-scope="props" >
        <tr>
        <template v-for="clientSegment in props.item" >
            <td>{{ clientSegment}}</td>
        </template>
        </tr>
      </template>
    </v-data-table>

  </div>


</template>

<script>
export default {
  data () {
    return {
      modal_details: false,
      clientSegments: [],
      segmentValue:"",
      headers: [
          { text: 'Rut', sortable: true, value: 'rut' },
          { text: 'Nombre', value: 'name', sortable: true },
          { text: 'Valor', value: 'value', sortable: true },
      ],
      segment:{},

    }
  },
  mounted(){
    this.getClients();
  },
  methods: {
    getClients(){
      var params = this.$route.params;
      this.segmentValue = params.name;
      this.segment = params.segment;
      const data = {company: {id: this.getCompany().id}}
      try {
        this.$http.get('client_segment/'+params.id,{
          params:{ data: data },
          headers:{
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
          }
        })
        .then(function(response){
          this.clientSegments = response.body.data
        }, function(response){
          if(typeof response.body.errors[0].details != "object"){
            alert(response.body.errors[0].details);
          }else{
            let message = []
            for(var key in response.body.errors[0].details){
              message.push(response.body.errors[0].details[key])
            }
            alert(message);
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    editItem (item) {
      // this.editedIndex = this.notifications.indexOf(item)
      // this.editedItem = Object.assign({}, item)
      // this.modal_details = true
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/segments/Index_client_segment.vue